import {Directive, ElementRef, forwardRef, HostListener} from '@angular/core';
import {AbstractControl, AsyncValidator, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

@Directive({
  selector: '[ValidNumber]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => ValidNumberDirective), multi: true
  }
  ]
})
export class ValidNumberDirective implements Validator {

  constructor(public el: ElementRef) {
  }

  validate(c: AbstractControl) {
    if (c.value < 0) {
      this.el.nativeElement.value = 0;
      return null;
    }
  }

  // @HostListener('keypress')
  // onFocusout() {
  //   if (this.el.nativeElement.value < 0) {
  //     console.log('invalid number', this.el.nativeElement.value);
  //     this.el.nativeElement.value = 0;
  //   }
  // }

}
